import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ChatSmileIcon = createIcon({
  displayName: 'ChatSmileIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M0,.0006H24v24H0Z" fill="none" />
      <path d="M0,.0006H24v24H0Z" fill="none" />
      <path
        d="M10,10v1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14,10v1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15.5,14.6879a5.32445,5.32445,0,0,1-7,0"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M7.1377,19.566a9.01637,9.01637,0,1,0-2.7038-2.7038"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M4.4339,16.86224,4.007,19.41742a.5.5,0,0,0,.57556.57556l2.555-.427"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect y="-0.00059" width="24" height="24" fill="none" />
    </>
  ),
})

const ChatSmile: FC<IconProps> = (props) => {
  return <CustomIcon as={ChatSmileIcon} {...props} />
}

export default memo(ChatSmile)
